import React from 'react';
import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs';
import IconButton from '@material-ui/core/IconButton';
import Link, { LinkProps } from '@material-ui/core/Link';
import useStyles from './styles';
import type { BreadcrumbNavigationProps } from './types';

const IconSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="24"
        height="24"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
    >
        <path d="M20 11v2H8l5.5 5.5l-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5L8 11h12z" fill="currentColor" />
    </svg>
);

const BackButton: React.FC<{ onBackPress?: () => void; isBackButton: boolean }> = ({ onBackPress, isBackButton }) => {
    const classes = useStyles();
    return isBackButton && onBackPress ? (
        <div className={classes.backPress}>
            <IconButton size="small" color="primary" onClick={onBackPress}>
                <IconSvg />
            </IconButton>
        </div>
    ) : null;
};

const BreadcrumbNavigation = <LinkType extends LinkProps>(props: BreadcrumbNavigationProps<LinkType>) => {
    const { onBackPress, items, componentLink: Component = Link, isBackButton = true, ...rest } = props;
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <BackButton onBackPress={onBackPress} isBackButton={isBackButton} />
            <MuiBreadcrumbs {...rest}>
                {items?.map((props, index) => {
                    return (
                        // @ts-ignore
                        <Component key={`data-breadcrumbs-${index}`} {...props} />
                    );
                })}
            </MuiBreadcrumbs>
        </div>
    );
};

export type { BreadcrumbNavigationProps };
export default BreadcrumbNavigation;
